// extracted by mini-css-extract-plugin
export var emailBlockLink = "_nv-0";